import React, { useEffect } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";

import Home from "./general/views/Home";
import Contacto from "./general/views/Contacto";
import Fundacion from "./general/views/Fundacion";
import FispUba from "./general/views/FispUba";
import TerminosCondiciones from "./general/views/TerminosCondiciones";
import Educativo from "./educativo/views/Educativo";
import Curso from "./educativo/views/Curso";
import Inscripcion from "./educativo/views/Inscripcion";
import InscripcionConfirmacion from "./educativo/views/InscripcionConfirmacion";
import EducativoWhatsAppFloat from "./educativo/components/EducativoWhatsAppFloat";
import PublicRouteMetaManager from "./general/components/common/PublicRouteMetaManager";
import Servicios from "./servicios/views/Servicios";
import WellnessCorporativo from "./servicios/views/WellnessCorporativo";
import ProyectosTecnologicosEnSalud from "./servicios/views/ProyectosTecnologicosEnSalud";
import MarketingYPublicidadEnSalud from "./servicios/views/MarketingYPublicidadEnSalud";
import ServiciosMedicos from "./servicios/views/ServiciosMedicos";
import ProduccionYCoberturaDeEventos from "./servicios/views/ProduccionYCoberturaDeEventos";
import CapacitacionLaboral from "./servicios/views/CapacitacionLaboral";
import FispTv from "./fisp-tv/views/FispTv";
import Noticia from "./fisp-tv/views/Noticia";
import Segmentos from "./fisp-tv/views/Segmentos";
import SegmentoCategoria from "./fisp-tv/views/SegmentoCategoria";
import FispTvAdminGuard from "./admin/components/AdminGuard";
import FispTvAdminLogin from "./admin/views/Login";
import FispTvAdminMenu from "./admin/views/Menu";
import FispTvAdminAgregarNota from "./admin/views/AgregarNota";
import FispTvAdminEditarNota from "./admin/views/EditarNota";
import FispTvAdminPrevisualizarNota from "./admin/views/PrevisualizarNota";
import FispTvAdminMetricas from "./admin/views/Metricas";
import FispTvAdminEditarHome from "./admin/views/EditarHome";

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.replace(/^#/, "");

      window.requestAnimationFrame(() => {
        const target = document.getElementById(targetId);

        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }

        window.scrollTo(0, 0);
      });

      return;
    }

    window.scrollTo(0, 0);
  }, [location.hash, location.pathname]);

  return null;
}

function LegacyNewsRedirect() {
  const { slug } = useParams();

  return <Navigate to={slug ? `/fisp-tv/${slug}` : "/fisp-tv"} replace />;
}

function LegacyFisptvRedirect() {
  const location = useLocation();
  const nextPath = location.pathname.replace(/^\/fisptv(?=\/|$)/, "/fisp-tv");

  return (
    <Navigate
      to={`${nextPath}${location.search}${location.hash}`}
      replace
    />
  );
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <PublicRouteMetaManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/index.html" element={<Navigate to="/" replace />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route
          path="/contacto.html"
          element={<Navigate to="/contacto" replace />}
        />
        <Route
          path="/terminos-y-condiciones"
          element={<TerminosCondiciones />}
        />
        <Route
          path="/terminos-condiciones"
          element={<Navigate to="/terminos-y-condiciones" replace />}
        />
        <Route
          path="/terminos-y-condiciones.html"
          element={<Navigate to="/terminos-y-condiciones" replace />}
        />

        <Route path="/educativo" element={<Educativo />} />
        <Route
          path="/educativo/admin"
          element={<Navigate to="/educativo" replace />}
        />
        <Route
          path="/educativo.html"
          element={<Navigate to="/educativo" replace />}
        />

        <Route path="/servicios" element={<Servicios />} />
        <Route
          path="/servicios.html"
          element={<Navigate to="/servicios" replace />}
        />
        <Route
          path="/servicios/wellness-corporativo"
          element={<WellnessCorporativo />}
        />
        <Route
          path="/servicios/proyectos-tecnologicos"
          element={<ProyectosTecnologicosEnSalud />}
        />
        <Route
          path="/servicios/marketing-publicidad"
          element={<MarketingYPublicidadEnSalud />}
        />
        <Route
          path="/servicios/servicios-medicos"
          element={<ServiciosMedicos />}
        />
        <Route
          path="/servicios/produccion-eventos"
          element={<ProduccionYCoberturaDeEventos />}
        />
        <Route
          path="/servicios/capacitacion-laboral"
          element={<CapacitacionLaboral />}
        />
        <Route
          path="/servicios/wellness-corporativo.html"
          element={<Navigate to="/servicios/wellness-corporativo" replace />}
        />
        <Route
          path="/servicios/proyectos-tecnologicos.html"
          element={<Navigate to="/servicios/proyectos-tecnologicos" replace />}
        />
        <Route
          path="/servicios/marketing-publicidad.html"
          element={<Navigate to="/servicios/marketing-publicidad" replace />}
        />
        <Route
          path="/servicios/servicios-medicos.html"
          element={<Navigate to="/servicios/servicios-medicos" replace />}
        />
        <Route
          path="/servicios/produccion-eventos.html"
          element={<Navigate to="/servicios/produccion-eventos" replace />}
        />
        <Route
          path="/servicios/capacitacion-laboral.html"
          element={<Navigate to="/servicios/capacitacion-laboral" replace />}
        />
        <Route
          path="/servicio-wellness.html"
          element={<Navigate to="/servicios/wellness-corporativo" replace />}
        />
        <Route
          path="/servicio-proyectos-tecnologicos.html"
          element={<Navigate to="/servicios/proyectos-tecnologicos" replace />}
        />
        <Route
          path="/servicio-marketing.html"
          element={<Navigate to="/servicios/marketing-publicidad" replace />}
        />
        <Route
          path="/servicio-medicos.html"
          element={<Navigate to="/servicios/servicios-medicos" replace />}
        />
        <Route
          path="/servicio-produccion-eventos.html"
          element={<Navigate to="/servicios/produccion-eventos" replace />}
        />
        <Route
          path="/servicio-capacitacion.html"
          element={<Navigate to="/servicios/capacitacion-laboral" replace />}
        />

        <Route path="/fundacion" element={<Fundacion />} />
        <Route path="/la-fundacion" element={<Fundacion />} />
        <Route
          path="/la-fundacion.html"
          element={<Navigate to="/fundacion" replace />}
        />

        <Route path="/fisp-tv" element={<FispTv />} />
        <Route
          path="/fisp-tv.html"
          element={<Navigate to="/fisp-tv" replace />}
        />
        <Route
          path="/portal-de-noticias"
          element={<Navigate to="/fisp-tv" replace />}
        />
        <Route path="/fisp-tv/segmentos" element={<Segmentos />} />
        <Route
          path="/fisp-tv/segmentos.html"
          element={<Navigate to="/fisp-tv/segmentos" replace />}
        />
        <Route path="/fisp-tv/segmentos/:slug" element={<SegmentoCategoria />} />
        <Route path="/fisp-tv/segmentos/:slug.html" element={<SegmentoCategoria />} />
        <Route path="/fisp-tv/login" element={<FispTvAdminLogin />} />
        <Route
          path="/portal-de-noticias/login"
          element={<Navigate to="/fisp-tv/login" replace />}
        />
        <Route
          path="/fisp-tv/admin"
          element={
              <FispTvAdminGuard>
              <FispTvAdminMenu />
            </FispTvAdminGuard>
          }
        />
        <Route
          path="/fisp-tv/admin/crear-nota"
          element={
            <FispTvAdminGuard>
              <FispTvAdminAgregarNota />
            </FispTvAdminGuard>
          }
        />
        <Route
          path="/fisp-tv/admin/editar-nota"
          element={
            <FispTvAdminGuard>
              <FispTvAdminEditarNota />
            </FispTvAdminGuard>
          }
        />
        <Route
          path="/fisp-tv/admin/previsualizar-nota"
          element={
            <FispTvAdminGuard>
              <FispTvAdminPrevisualizarNota />
            </FispTvAdminGuard>
          }
        />
        <Route
          path="/fisp-tv/admin/previsualizar-nota/:slug"
          element={
            <FispTvAdminGuard>
              <FispTvAdminPrevisualizarNota />
            </FispTvAdminGuard>
          }
        />
        <Route
          path="/fisp-tv/admin/metricas"
          element={
            <FispTvAdminGuard>
              <FispTvAdminMetricas />
            </FispTvAdminGuard>
          }
        />
        <Route
          path="/fisp-tv/admin/editar-home"
          element={
            <FispTvAdminGuard>
              <FispTvAdminEditarHome />
            </FispTvAdminGuard>
          }
        />
        <Route path="/fisp-tv/:slug.html" element={<LegacyNewsRedirect />} />
        <Route path="/fisp-tv/:slug" element={<Noticia />} />
        <Route path="/noticias/:slug" element={<LegacyNewsRedirect />} />
        <Route path="/noticias/:slug.html" element={<LegacyNewsRedirect />} />
        <Route path="/fisptv/*" element={<LegacyFisptvRedirect />} />

        <Route path="/fisp-uba" element={<FispUba />} />
        <Route
          path="/fisp-uba.html"
          element={<Navigate to="/fisp-uba" replace />}
        />
        <Route
          path="/pages/fisp-uba.html"
          element={<Navigate to="/fisp-uba" replace />}
        />

        <Route path="/cursos/:slug" element={<Curso family="cursos" />} />
        <Route path="/cursos/:slug.html" element={<Curso family="cursos" />} />
        <Route
          path="/cursos/:slug/inscripcion"
          element={<Inscripcion />}
        />
        <Route
          path="/cursos/:slug/inscripcion/confirmacion"
          element={<InscripcionConfirmacion />}
        />
        <Route
          path="/diplomaturas/:slug"
          element={<Curso family="diplomaturas" />}
        />
        <Route
          path="/diplomaturas/:slug.html"
          element={<Curso family="diplomaturas" />}
        />
        <Route
          path="/diplomaturas/:slug/inscripcion"
          element={<Inscripcion />}
        />
        <Route
          path="/diplomaturas/:slug/inscripcion/confirmacion"
          element={<InscripcionConfirmacion />}
        />
        <Route path="/posgrados/:slug" element={<Curso family="posgrados" />} />
        <Route
          path="/posgrados/:slug.html"
          element={<Curso family="posgrados" />}
        />
        <Route
          path="/posgrados/:slug/inscripcion"
          element={<Inscripcion />}
        />
        <Route
          path="/posgrados/:slug/inscripcion/confirmacion"
          element={<InscripcionConfirmacion />}
        />

        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
      <EducativoWhatsAppFloat />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
